/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import AdminCompany from '../model/AdminCompany';
import CompanyOffer from '../model/CompanyOffer';
import CompanyOfferItemWithCompany from '../model/CompanyOfferItemWithCompany';
import DefaultResponse from '../model/DefaultResponse';
import InlineResponse2001 from '../model/InlineResponse2001';
import InlineResponse2002 from '../model/InlineResponse2002';
import InlineResponse2003 from '../model/InlineResponse2003';
import Status from '../model/Status';

/**
* Admin service.
* @module api/AdminApi
* @version v1
*/
export default class AdminApi {

    /**
    * Constructs a new AdminApi. 
    * @alias module:api/AdminApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Dashboard info
     * @param {Object} opts Optional parameters
     * @param {String} opts.search name, phone, nif, text and location filtering
     * @param {Number} opts.status status 0 disabled / 1 enabled
     * @param {Number} opts.completed 1 yes / 0 no
     * @param {Number} opts.withOffers 1 yes / 0 no
     * @param {Number} opts.withCandidates 1 yes / 0 no
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse2002} and HTTP response
     */
    adminCompaniesDashboardGetWithHttpInfo(opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'search': opts['search'],
        'status': opts['status'],
        'completed': opts['completed'],
        'with_offers': opts['withOffers'],
        'with_candidates': opts['withCandidates']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = InlineResponse2002;
      return this.apiClient.callApi(
        '/admin/companies/dashboard', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Dashboard info
     * @param {Object} opts Optional parameters
     * @param {String} opts.search name, phone, nif, text and location filtering
     * @param {Number} opts.status status 0 disabled / 1 enabled
     * @param {Number} opts.completed 1 yes / 0 no
     * @param {Number} opts.withOffers 1 yes / 0 no
     * @param {Number} opts.withCandidates 1 yes / 0 no
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse2002}
     */
    adminCompaniesDashboardGet(opts) {
      return this.adminCompaniesDashboardGetWithHttpInfo(opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Actualizar perfil de empresa
     * @param {Number} id Company Id
     * @param {Object} opts Optional parameters
     * @param {String} opts.name Company name
     * @param {String} opts.nif Company nif
     * @param {String} opts.text Company text
     * @param {String} opts.contactEmail Contact email
     * @param {String} opts.contactName Contact name
     * @param {String} opts.contactSurname Contact surname
     * @param {String} opts.contactPhone Contact phone
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DefaultResponse} and HTTP response
     */
    adminCompaniesEditIdPutWithHttpInfo(id, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling adminCompaniesEditIdPut");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        'name': opts['name'],
        'nif': opts['nif'],
        'text': opts['text'],
        'contact_email': opts['contactEmail'],
        'contact_name': opts['contactName'],
        'contact_surname': opts['contactSurname'],
        'contact_phone': opts['contactPhone']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = DefaultResponse;
      return this.apiClient.callApi(
        '/admin/companies/edit/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Actualizar perfil de empresa
     * @param {Number} id Company Id
     * @param {Object} opts Optional parameters
     * @param {String} opts.name Company name
     * @param {String} opts.nif Company nif
     * @param {String} opts.text Company text
     * @param {String} opts.contactEmail Contact email
     * @param {String} opts.contactName Contact name
     * @param {String} opts.contactSurname Contact surname
     * @param {String} opts.contactPhone Contact phone
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DefaultResponse}
     */
    adminCompaniesEditIdPut(id, opts) {
      return this.adminCompaniesEditIdPutWithHttpInfo(id, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Export data
     * @param {Object} opts Optional parameters
     * @param {String} opts.search name, phone, nif, text and location filtering
     * @param {Number} opts.status status 0 disabled / 1 enabled
     * @param {Number} opts.completed 1 yes / 0 no
     * @param {Number} opts.withOffers 1 yes / 0 no
     * @param {Number} opts.withCandidates 1 yes / 0 no
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link File} and HTTP response
     */
    adminCompaniesExportGetWithHttpInfo(opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'search': opts['search'],
        'status': opts['status'],
        'completed': opts['completed'],
        'with_offers': opts['withOffers'],
        'with_candidates': opts['withCandidates']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
      let returnType = File;
      return this.apiClient.callApi(
        '/admin/companies/export', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Export data
     * @param {Object} opts Optional parameters
     * @param {String} opts.search name, phone, nif, text and location filtering
     * @param {Number} opts.status status 0 disabled / 1 enabled
     * @param {Number} opts.completed 1 yes / 0 no
     * @param {Number} opts.withOffers 1 yes / 0 no
     * @param {Number} opts.withCandidates 1 yes / 0 no
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link File}
     */
    adminCompaniesExportGet(opts) {
      return this.adminCompaniesExportGetWithHttpInfo(opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Se llama desde el core, no hay pantalla todavia
     * @param {Object} opts Optional parameters
     * @param {String} opts.search name, phone, nif, text and location filtering
     * @param {Number} opts.status status 0 disabled / 1 enabled
     * @param {Number} opts.completed 1 yes / 0 no
     * @param {Number} opts.withOffers 1 yes / 0 no
     * @param {Number} opts.withCandidates 1 yes / 0 no
     * @param {Number} opts.page page number (default 1)
     * @param {Number} opts.limit companies per page (default 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse2001} and HTTP response
     */
    adminCompaniesGetWithHttpInfo(opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'search': opts['search'],
        'status': opts['status'],
        'completed': opts['completed'],
        'with_offers': opts['withOffers'],
        'with_candidates': opts['withCandidates'],
        'page': opts['page'],
        'limit': opts['limit']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = InlineResponse2001;
      return this.apiClient.callApi(
        '/admin/companies', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Se llama desde el core, no hay pantalla todavia
     * @param {Object} opts Optional parameters
     * @param {String} opts.search name, phone, nif, text and location filtering
     * @param {Number} opts.status status 0 disabled / 1 enabled
     * @param {Number} opts.completed 1 yes / 0 no
     * @param {Number} opts.withOffers 1 yes / 0 no
     * @param {Number} opts.withCandidates 1 yes / 0 no
     * @param {Number} opts.page page number (default 1)
     * @param {Number} opts.limit companies per page (default 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse2001}
     */
    adminCompaniesGet(opts) {
      return this.adminCompaniesGetWithHttpInfo(opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Dar de baja / vetar empresa
     * @param {Number} id Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DefaultResponse} and HTTP response
     */
    adminCompaniesIdDeleteWithHttpInfo(id) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling adminCompaniesIdDelete");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = DefaultResponse;
      return this.apiClient.callApi(
        '/admin/companies/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Dar de baja / vetar empresa
     * @param {Number} id Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DefaultResponse}
     */
    adminCompaniesIdDelete(id) {
      return this.adminCompaniesIdDeleteWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Se llama desde el core, no hay pantalla todavia
     * @param {Number} id Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/AdminCompany>} and HTTP response
     */
    adminCompaniesIdGetWithHttpInfo(id) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling adminCompaniesIdGet");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [AdminCompany];
      return this.apiClient.callApi(
        '/admin/companies/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Se llama desde el core, no hay pantalla todavia
     * @param {Number} id Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/AdminCompany>}
     */
    adminCompaniesIdGet(id) {
      return this.adminCompaniesIdGetWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Para cambiar desde core el status de aprovado de la empresa
     * @param {Number} id Id
     * @param {Object} opts Optional parameters
     * @param {module:model/Status} opts.status 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Boolean} and HTTP response
     */
    adminCompaniesIdPutWithHttpInfo(id, opts) {
      opts = opts || {};
      let postBody = opts['status'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling adminCompaniesIdPut");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = 'Boolean';
      return this.apiClient.callApi(
        '/admin/companies/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Para cambiar desde core el status de aprovado de la empresa
     * @param {Number} id Id
     * @param {Object} opts Optional parameters
     * @param {module:model/Status} opts.status 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Boolean}
     */
    adminCompaniesIdPut(id, opts) {
      return this.adminCompaniesIdPutWithHttpInfo(id, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Dashboard de ofertas
     * @param {Object} opts Optional parameters
     * @param {Number} opts.company company_id to filter
     * @param {String} opts.search name, phone, nif, text and location filtering
     * @param {Number} opts.status status 0 disabled / 1 enabled
     * @param {Number} opts.modality 0 normal / 1 fct / 2 dual
     * @param {Number} opts.city city id from fixture
     * @param {Number} opts.academicProgramScope academic program scope id from fixture
     * @param {String} opts.minimalPublishDate display offers published prior to the specified date (format Y-m-d)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse2003} and HTTP response
     */
    adminOffersDashboardGetWithHttpInfo(opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'company': opts['company'],
        'search': opts['search'],
        'status': opts['status'],
        'modality': opts['modality'],
        'city': opts['city'],
        'academic_program_scope': opts['academicProgramScope'],
        'minimal_publish_date': opts['minimalPublishDate']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = InlineResponse2003;
      return this.apiClient.callApi(
        '/admin/offers/dashboard', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Dashboard de ofertas
     * @param {Object} opts Optional parameters
     * @param {Number} opts.company company_id to filter
     * @param {String} opts.search name, phone, nif, text and location filtering
     * @param {Number} opts.status status 0 disabled / 1 enabled
     * @param {Number} opts.modality 0 normal / 1 fct / 2 dual
     * @param {Number} opts.city city id from fixture
     * @param {Number} opts.academicProgramScope academic program scope id from fixture
     * @param {String} opts.minimalPublishDate display offers published prior to the specified date (format Y-m-d)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse2003}
     */
    adminOffersDashboardGet(opts) {
      return this.adminOffersDashboardGetWithHttpInfo(opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Exportacion a excel de ofertas
     * @param {Object} opts Optional parameters
     * @param {Number} opts.company company_id to filter
     * @param {String} opts.search name, phone, nif, text and location filtering
     * @param {Number} opts.status status 0 disabled / 1 enabled
     * @param {Number} opts.modality 0 normal / 1 fct / 2 dual
     * @param {Number} opts.city city id from fixture
     * @param {Number} opts.academicProgramScope academic program scope id from fixture
     * @param {String} opts.minimalPublishDate display offers published prior to the specified date (format Y-m-d)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link File} and HTTP response
     */
    adminOffersExportGetWithHttpInfo(opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'company': opts['company'],
        'search': opts['search'],
        'status': opts['status'],
        'modality': opts['modality'],
        'city': opts['city'],
        'academic_program_scope': opts['academicProgramScope'],
        'minimal_publish_date': opts['minimalPublishDate']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
      let returnType = File;
      return this.apiClient.callApi(
        '/admin/offers/export', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Exportacion a excel de ofertas
     * @param {Object} opts Optional parameters
     * @param {Number} opts.company company_id to filter
     * @param {String} opts.search name, phone, nif, text and location filtering
     * @param {Number} opts.status status 0 disabled / 1 enabled
     * @param {Number} opts.modality 0 normal / 1 fct / 2 dual
     * @param {Number} opts.city city id from fixture
     * @param {Number} opts.academicProgramScope academic program scope id from fixture
     * @param {String} opts.minimalPublishDate display offers published prior to the specified date (format Y-m-d)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link File}
     */
    adminOffersExportGet(opts) {
      return this.adminOffersExportGetWithHttpInfo(opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * List offers
     * @param {Object} opts Optional parameters
     * @param {Number} opts.company company_id to filter
     * @param {String} opts.search name, phone, nif, text and location filtering
     * @param {Number} opts.status status 0 disabled / 1 enabled
     * @param {Number} opts.modality 0 normal / 1 fct / 2 dual
     * @param {Number} opts.city city id from fixture
     * @param {Number} opts.academicProgramScope academic program scope id from fixture
     * @param {String} opts.minimalPublishDate display offers published prior to the specified date (format Y-m-d)
     * @param {Number} opts.page page number (default 1)
     * @param {Number} opts.limit companies per page (default 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/CompanyOfferItemWithCompany>} and HTTP response
     */
    adminOffersGetWithHttpInfo(opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'company': opts['company'],
        'search': opts['search'],
        'status': opts['status'],
        'modality': opts['modality'],
        'city': opts['city'],
        'academic_program_scope': opts['academicProgramScope'],
        'minimal_publish_date': opts['minimalPublishDate'],
        'page': opts['page'],
        'limit': opts['limit']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [CompanyOfferItemWithCompany];
      return this.apiClient.callApi(
        '/admin/offers', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * List offers
     * @param {Object} opts Optional parameters
     * @param {Number} opts.company company_id to filter
     * @param {String} opts.search name, phone, nif, text and location filtering
     * @param {Number} opts.status status 0 disabled / 1 enabled
     * @param {Number} opts.modality 0 normal / 1 fct / 2 dual
     * @param {Number} opts.city city id from fixture
     * @param {Number} opts.academicProgramScope academic program scope id from fixture
     * @param {String} opts.minimalPublishDate display offers published prior to the specified date (format Y-m-d)
     * @param {Number} opts.page page number (default 1)
     * @param {Number} opts.limit companies per page (default 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/CompanyOfferItemWithCompany>}
     */
    adminOffersGet(opts) {
      return this.adminOffersGetWithHttpInfo(opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * details of a offer
     * @param {Number} id id of the offer
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CompanyOffer} and HTTP response
     */
    adminOffersIdGetWithHttpInfo(id) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling adminOffersIdGet");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = CompanyOffer;
      return this.apiClient.callApi(
        '/admin/offers/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * details of a offer
     * @param {Number} id id of the offer
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CompanyOffer}
     */
    adminOffersIdGet(id) {
      return this.adminOffersIdGetWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
